import { GROUP_PARAM } from '../entry/groupFilter';
import { SUBGROUP_PARAM } from '../entry/subgroupFilter';
import type { OpenerDescalceRow } from '../../api/useOpenerDescalce';

/**
 * `Go` deep-link target: `/predictions/opening?group={id}&subgroup={sid}`.
 * `null` for an ungrouped row (core engine) — there is no group page to open.
 * Pure, split out of `DescalceCells.tsx` so that file only exports
 * components (react-refresh/only-export-components).
 */
export function buildDescalceDeepLink(row: OpenerDescalceRow): string | null {
  if (!row.group.id) return null;
  const params = new URLSearchParams();
  params.set(GROUP_PARAM, row.group.id);
  if (row.subgroupId) params.set(SUBGROUP_PARAM, row.subgroupId);
  return `/predictions/opening?${params.toString()}`;
}
